export default function isEdge() {
    return navigator.userAgentData?.brands.some(b => b.brand.includes("Microsoft Edge")) || /Edg/.test(navigator.userAgent);
}